import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData, postData } from "src/utils/axios/serverHelper";
import { formatDate } from "src/utils/string/stringUtil";
import { PRD5010_R01Dto, PRD5010_R01ProductResultDto } from "./Dto_PRD5010_R01";
import { PRD5010_R01Filter } from "./Store_PRD5010_R01";

const baseUrl = `${config.apiUrl}/PRD5010_R01`;

const getParams = (filter: Partial<PRD5010_R01Filter>) => ({
    compCd: filter.compCd || undefined,
    kpicertkey: filter.kpicertkey || undefined,
    kpifldcd: filter.kpifldcd || undefined,
    startDate: filter.ocrdttmDateRange?.from
        ? formatDate(filter.ocrdttmDateRange.from)
        : undefined,
    endDate: filter.ocrdttmDateRange?.to
        ? formatDate(filter.ocrdttmDateRange.to)
        : undefined,
});

export const getPRD5010_R01List = async (option: string, filter: Partial<PRD5010_R01Filter>) => {
    const url = `${baseUrl}/${option}`;
    return await getData<ResponseDto<PRD5010_R01Dto[]>>(url, { params: getParams(filter) });
};

export const getPRD5010_R01ProductResultList = async (filter: Partial<PRD5010_R01Filter>) => {
    const url = `${baseUrl}/productResult/`;
    return await getData<ResponseDto<PRD5010_R01ProductResultDto[]>>(url, {
        params: getParams(filter),
    });
};

export const exportPRD5010_R01Excel = async (option: string, filter: Partial<PRD5010_R01Filter>) => {
    const url = `${baseUrl}/excel/${option}`;
    return await getData<ResponseDto<string>>(url, { params: getParams(filter) });
};

export const postPRD5010_R01KpidataInsert = async (jobdate: string) => {
    const url = `${baseUrl}/kpidata/insert`;
    return await postData<undefined, ResponseDto<void>>(url, undefined, {
        params: { jobdate },
    });
};
